import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Growers from './pages/Growers';
import Sensors from './pages/Sensors';
import SensorDetail from './pages/SensorDetail';
import Locations from './pages/Locations';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import BatchImports from './pages/BatchImports';
import BatchImportDetail from './pages/BatchImportDetail';
import ThresholdsOverview from './pages/ThresholdsOverview';
import Gateways from './pages/Gateways';
import GatewayDetail from './pages/GatewayDetail';
import { authService } from './services/authService';

const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  return authService.isAuthenticated() ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/growers"
          element={
            <PrivateRoute>
              <Growers />
            </PrivateRoute>
          }
        />
        <Route
          path="/sensors"
          element={
            <PrivateRoute>
              <Sensors />
            </PrivateRoute>
          }
        />
        <Route
          path="/sensors/:id"
          element={
            <PrivateRoute>
              <SensorDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/locations"
          element={
            <PrivateRoute>
              <Locations />
            </PrivateRoute>
          }
        />
        <Route
          path="/batch-imports"
          element={
            <PrivateRoute>
              <BatchImports />
            </PrivateRoute>
          }
        />
        <Route
          path="/batch-imports/:id"
          element={
            <PrivateRoute>
              <BatchImportDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/thresholds"
          element={
            <PrivateRoute>
              <ThresholdsOverview />
            </PrivateRoute>
          }
        />
        <Route
          path="/gateways"
          element={
            <PrivateRoute>
              <Gateways />
            </PrivateRoute>
          }
        />
        <Route
          path="/gateways/:gatewayId"
          element={
            <PrivateRoute>
              <GatewayDetail />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  );
}

export default App;
